pageId = "page-project-calendar-events"
page = "#" + pageId

$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  tower.initCalendarEventsSelector()

